var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEHeatingValveRoomThermostatic = function SvgEHeatingValveRoomThermostatic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 285,
    width: 28,
    height: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 280,
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "464.01 289.99 476.5 282.86 476.49 297.14 464.01 289.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476,283.72v12.55s-10.98-6.29-10.98-6.29l10.98-6.27M477,282l-14,7.99,13.99,8.01v-16h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "449.51 282.86 461.99 289.99 449.5 297.14 449.51 282.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.01,283.72l10.98,6.27-10.98,6.29v-12.55M449.01,282v16s13.99-8.01,13.99-8.01l-13.99-7.99h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 258,
    width: 12,
    height: 22,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,259v20h-10v-20h10M469,258h-12v22h12v-22h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 462.5,
    y: 262.48,
    width: 1,
    height: 13.04,
    transform: "translate(-12.52 515.2) rotate(-57.53)"
  }))))));
};
export default SvgEHeatingValveRoomThermostatic;